import { defineMessages } from '@dragonraider5/react-intl'

import * as validationsKeys from './constants'

export default defineMessages({
  [validationsKeys.REQUIRED]: {
    id: 'utils.validations.messages.REQUIRED',
    description: 'Default validation message for required field',
    defaultMessage: 'Por favor, rellena este campo.'
  },
  [validationsKeys.EMAIL]: {
    id: 'utils.validations.messages.EMAIL',
    description: 'Default validation message for email field',
    defaultMessage: 'Por favor, introduce una dirección e-mail válida.'
  },
  [validationsKeys.PASSWORD]: {
    id: 'utils.validations.messages.PASSWORD',
    description: 'Default validation message for password field',
    defaultMessage: 'Por favor, introduce una contraseña que cumpla los requisitos.'
  },
  [validationsKeys.URL]: {
    id: 'utils.validations.messages.URL',
    description: 'Default validation message for url field',
    defaultMessage: 'Por favor, introduce una url válida.'
  },
  [validationsKeys.MIN_NUMBER]: {
    id: 'utils.validations.messages.MIN_NUMBER',
    description: 'Default validation message for number min field',
    defaultMessage: 'Lo sentimos, el valor no puede ser negativo.'
  },
  [validationsKeys.MIN_30000]: {
    id: 'utils.validations.messages.MIN_30000',
    description: 'Default validation message for min 30.000 field',
    defaultMessage: 'Lo sentimos, el importe mínimo tiene que ser de 30.000€.'
  },
  [validationsKeys.MIN_50000]: {
    id: 'utils.validations.messages.MIN_50000',
    description: 'Default validation message for nax. 50.000 field',
    defaultMessage: 'Lo sentimos, el importe mínimo tiene que ser de 50.000€.'
  },
  [validationsKeys.NIF_NIE]: {
    id: 'utils.validations.messages.NIF_NIE',
    description: 'Default validation message for nif nie field',
    defaultMessage: 'Por favor, introduce un DNI o NIE válido.'
  },
  [validationsKeys.CIF]: {
    id: 'utils.validations.messages.CIF',
    description: 'Default validation message for CIF field',
    defaultMessage: 'Por favor, introduce un NIF válido.'
  },
  [validationsKeys.ZIP_CODE]: {
    id: 'utils.validations.messages.ZIP_CODE',
    description: 'Default validation message for zip field',
    defaultMessage: 'Por favor, introduce un código postal válido.'
  },
  [validationsKeys.PHONE_NUMBER]: {
    id: 'utils.validations.messages.PHONE_NUMBER',
    description: 'Default validation message for phone number field',
    defaultMessage: 'Por favor, introduce un número de teléfono válido.'
  },
  [validationsKeys.IS_TRUE]: {
    id: 'utils.validations.messages.IS_TRUE',
    description: 'Default validation message for checkbox checked field',
    defaultMessage: 'Debes marcar este campo para poder continuar.'
  },
  [validationsKeys.IS_FALSE]: {
    id: 'utils.validations.messages.IS_FALSE',
    description: 'Default validation message for checkbox unchecked field',
    defaultMessage: 'Debes desmarcar este campo para poder continuar.'
  },
  [validationsKeys.IS_VALID_DATE]: {
    id: 'utils.validations.messages.IS_VALID_DATE',
    description: 'Default validation message invalid date',
    defaultMessage: 'Por favor, introduce una fecha en el formato marcado.'
  },
  [validationsKeys.MAX_DATE]: {
    id: 'utils.validations.messages.MAX_DATE',
    description: 'Default validation message for max date',
    defaultMessage: 'Max DATE'
  },
  [validationsKeys.MIN_DATE]: {
    id: 'utils.validations.messages.MIN_DATE',
    description: 'Default validation message for min date',
    defaultMessage: 'Lo sentimos, la fecha tiene que ser una fecha futura.'
  }
})
